
<div *ngIf="messageService.messages.length" id="container1">
    <div id="fixed"><h2> Dev Logs
        <button class="clear" (click)="messageService.clear()">Clear messages</button>
    </h2></div>
    
    <div *ngFor='let message of messageService.messages'> {{message}} </div>
    
  </div>